import React from 'react'
import { Link } from 'react-router-dom'
const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-semibold text-lg mb-4">NovaForge</h3>
            <p className="text-sm text-gray-600">Yapay Zeka İK Çözümleri</p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">İletişim</h3>
            <p className="text-sm text-gray-600">
              Destek ve sorularınız için bizimle iletişime geçin.
            </p>
            <p className="text-sm text-gray-600 mt-2">Email: contact@novaforge.tech</p>
          </div>
        </div>

        <div className="border-t mt-8 pt-8 text-center">
          <p className="text-sm text-gray-600">
            &copy; {new Date().getFullYear()} NovaForge. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  )
}
export default Footer
